// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__a5XKh","footer":"styles_footer__nqJBq"};